import {AdminSelectContainerContext, styles as adminSelectStyles} from "components/admin/select-container"
import React, {useContext, useEffect, useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import {ChalkyLayoutInputContainerContext} from "components/chalky-layout/input-container"
import {styles as chalkyLayoutSelectStyles} from "components/chalky-layout/select-container"
import HayaSelect from "haya-select/build/select"
import {incorporate} from "incorporator"
import {InputContainerContext} from "components/inputs/input-container"
import memo from "set-state-compare/build/memo"
import {useForm} from "@kaspernj/api-maker/build/form"
import useInput from "@kaspernj/api-maker/build/use-input"
import {useModals} from "components/modal"

export default memo(shapeComponent(class WoofHayaSelect extends ShapeComponent {
  setup() {
    const {inputProps, restProps} = useInput({props: this.props, wrapperOptions: {type: "select"}})
    const defaultValue = inputProps.defaultValue
    const defaultValues = inputProps.defaultValues

    this.form = useForm()
    this.modals = useModals()
    this.setInstance({inputProps, restProps})

    useMemo(() => {
      if (!this.form || !inputProps.name) return

      if (typeof defaultValue != "undefined") {
        this.form.setValue(inputProps.name, defaultValue)
      } else if (Array.isArray(defaultValues) && defaultValues.length > 0) {
        this.form.setValue(inputProps.name, this.props.multiple ? defaultValues : defaultValues[0])
      }
    }, [])

    useEffect(() => () => {
      if (this.form && inputProps.name) {
        this.form.unsetValue(inputProps.name)
      }
    }, [this.form, inputProps.name])

    this.useStates({focus: false, valuePresent: this.tt.valuePresent()})
  }

  valuePresent = () => {
    if (this.tt.inputProps?.defaultValues?.length > 0 || this.tt.inputProps?.values?.length > 0) {
      return true
    }

    return false
  }

  render() {
    const adminSelectContainerContext = useContext(AdminSelectContainerContext)
    const chalkyLayoutInputContainerContext = useContext(ChalkyLayoutInputContainerContext)
    const inputContainerContext = useContext(InputContainerContext)
    const {restProps: restPropsFromUseInput} = this.tt
    const {styles = {}, woofInputStyling} = this.props
    const {
      containerProps: _containerProps,
      hint: _hint,
      label: _label,
      onBlur: _onBlur,
      onChange: _onChange,
      onFocus: _onFocus,
      ...restProps
    } = restPropsFromUseInput

    if (adminSelectContainerContext == "withinAdminSelectContainer") {
      incorporate(styles, adminSelectStyles)
    }

    if (chalkyLayoutInputContainerContext == "withinChalkyLayoutInputContainer") {
      incorporate(styles, chalkyLayoutSelectStyles)

      if (this.s.focus) {
        styles.selectContainer.backgroundColor = "#fff"
        styles.selectContainer.border = "1px solid #fff"
        styles.selectContainer.boxShadow = "0px 14px 40px 0px rgba(44, 44, 150, 0.2)"
      }

      if (!this.s.focus && this.s.valuePresent) {
        styles.selectContainer.border = "1px solid #d6e2f9"
      }
    }

    const selectContainerStyleActual = Object.assign({}, styles.selectContainer)
    const hiddenInputName = restProps.name || this.props.id

    if (inputContainerContext == "withinInputContainer") {
      selectContainerStyleActual.paddingTop = 17
      selectContainerStyleActual.paddingRight = 26
      selectContainerStyleActual.paddingBottom = 17
      selectContainerStyleActual.paddingLeft = 26
      selectContainerStyleActual.border = 0
      selectContainerStyleActual.background = "transparent"
    }

    styles.selectContainer = selectContainerStyleActual

    if (woofInputStyling) {
      if (!("optionPresentationText" in styles)) styles.optionPresentationText = {}

      styles.optionPresentationText.color = "#666"
      styles.optionPresentationText.fontSize ||= 17

      if (!("currentSelected" in styles)) styles.currentSelected = {}

      styles.currentSelected.overflow = "hidden"
      styles.currentSelected.whiteSpace = "nowrap"

      if (!("optionsContainer" in styles)) styles.optionsContainer = {}

      styles.optionsContainer.border = "1px solid #dcdcdc"

      selectContainerStyleActual.paddingTop = 17
      selectContainerStyleActual.paddingRight = 26
      selectContainerStyleActual.paddingBottom = 17
      selectContainerStyleActual.paddingLeft = 26
      selectContainerStyleActual.border = "1px solid #dcdcdc"
      selectContainerStyleActual.borderRadius = 10

      if (!("chevronContainer" in styles)) styles.chevronContainer = {}

      styles.chevronContainer.marginRight = undefined
    }

    let optionsPortal = true

    if (this.modals.active) {
      optionsPortal = false
    }

    return (
      <HayaSelect
        onBlur={this.tt.onBlur}
        onChange={this.tt.onChange}
        onFocus={this.tt.onFocus}
        optionsPortal={optionsPortal}
        styles={styles}
        {...restProps}
        name={hiddenInputName}
      />
    )
  }

  onBlur = (...args) => {
    if (this.props.onBlur) {
      this.p.onBlur(...args)
    }

    this.setState({focus: false})
  }

  onChange = ({options, ...restProps}) => {
    // Set form value if any
    if (this.props.name && this.form) {
      const values = options.map((option) => option.value)
      let value

      if (this.props.multiple) {
        value = values
      } else {
        value = values[0]
      }

      this.form.setValue(this.props.name, value)
    }

    if (this.props.onChange) {
      this.props.onChange({options, ...restProps})
    }

    this.setState({valuePresent: options.length > 0})
  }

  onFocus = (...args) => {
    if (this.props.onFocus) {
      this.p.onFocus(...args)
    }

    this.setState({focus: true})
  }
}))
